// src/modules/materials/components/StockTable.js
// Stok tablosu bileşeni

import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, IconButton, Typography, Chip, Box, Checkbox
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const StockTable = ({ stocks, selectedIds, onToggle }) => {
    return (
        <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400 }}>
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Ürün Adı</TableCell>
                        <TableCell align="right">Stok</TableCell>
                        <TableCell align="right">Alış Fiyatı</TableCell>
                        <TableCell align="right">Satış Fiyatı</TableCell>
                        <TableCell align="center">İşlem</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {stocks.map((stock) => (
                        <TableRow
                            key={stock.id}
                            hover
                            selected={selectedIds.has(stock.id)}
                            sx={{
                                bgcolor: stock.stokAdedi === 0 ? 'error.light' : 'inherit',
                                opacity: stock.stokAdedi === 0 ? 0.6 : 1
                            }}
                        >
                            <TableCell>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {stock.urunAdi}
                                    {stock.stokAdedi === 0 && (
                                        <Chip label="Stokta Yok" size="small" color="error" />
                                    )}
                                </Box>
                            </TableCell>
                            <TableCell align="right">
                                <Chip
                                    label={stock.stokAdedi}
                                    size="small"
                                    color={stock.stokAdedi > 10 ? 'success' : stock.stokAdedi > 0 ? 'warning' : 'error'}
                                />
                            </TableCell>
                            <TableCell align="right">
                                {Number(stock.alisFiyati || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}
                            </TableCell>
                            <TableCell align="right">
                                {Number(stock.satisFiyati).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}
                            </TableCell>
                            <TableCell align="center">
                                <Checkbox
                                    checked={selectedIds.has(stock.id)}
                                    onChange={() => onToggle(stock)}
                                    disabled={stock.stokAdedi === 0}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                    {stocks.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={5} align="center">
                                <Typography color="text.secondary">Ürün bulunamadı</Typography>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default StockTable;
